module.exports = __webpack_public_path__ + "img/playbar_prev_white.89401f3f.svg";